export default __webpack_public_path__ + "static/media/3stepweightloss_1.b424a28b.jpg";